import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 240px;
  margin: 20px auto 0 auto;
  text-align: left;
`;

export const TierInput = styled.label`
  &&& {
    display: inline-block;
    margin: 8px 32px;

    span {
      margin-right: 8px;
    }

    input {
      display: inline-block;
      font-size: 14px;
      line-height: 12px;
      height: 24px;
      padding: 0 14px 0 4px;
      width: 48px;
    }
  }
`;

export const Label = styled.span`
  display: inline-block;
  width: 48px;
  text-align: left;
`;

export const AddTier = styled.button`
  &&& {
    background: none;
    text-shadow: none;
    color: #6c727f;
    font-size: 14px;
    font-weight: 400;
    padding: 0;
    height: auto;
    line-height: initial;
    margin: 12px 0 12px 24px;

    &:hover {
      text-shadow: none;
      background: none;
      text-decoration: underline;
    }

    &:focus {
      outline: 1px solid rgba(74, 144, 226, 0.3);
    }
  }
`;

export const RemoveTier = styled.button`
  &&& {
    text-shadow: none;
    color: #9b9b9b;
    padding: 0;
    margin: 0;
    display: inline-flex;
    background: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;

    i {
      margin: 0;
      font-size: 12px;
    }

    &:hover {
      text-shadow: none;
      background: #eee;
    }

    &:focus {
      box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.3);
    }
  }
`;

export const Percent = styled.span`
  margin-left: -12px;
`;
